import { getScreens } from './getScreens';
import { getScreensFilterOptions } from './getScreensFilterOptions/getScreensFilterOptions';
import { getProxyComponents } from './getProxyComponents';

export const screensService = {
  get: getScreens,
  getFilterOptions: getScreensFilterOptions,
  getProxyComponents: getProxyComponents,
};
